import { render } from "./svgIcon.vue?vue&type=template&id=54229786&scoped=true"
import script from "./svgIcon.vue?vue&type=script&lang=js"
export * from "./svgIcon.vue?vue&type=script&lang=js"

import "./svgIcon.vue?vue&type=style&index=0&id=54229786&lang=less&scoped=true"

import exportComponent from "D:\\myWorkspace\\CoreServiceAzure\\CoreServiceCloud\\MyNews\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54229786"]])

export default __exports__